export default __webpack_public_path__ + "static/media/gallery_05.6e2c053e.jpg";